export default '/pricing/windows';
